<template>
  <page-layout>
    <div slot="headerContent">
      <!-- <div class="title">{{ timeFix }}，{{ user.userName }}<span class="welcome-text">，{{ welcome() }}</span></div>
      <div v-if="user.roles" style="margin-bottom:16px;">Roles：{{ this.roleNames }}</div> -->
    </div>
    <div slot="extra">
      <!-- <a-row class="more-info" v-if="topCount">
        <a-col :span="8">
          <head-info title="Survey" :content="topCount.surveyInstanceCount + ''" :center="false" :bordered="false"/>
        </a-col>
        <a-col :span="8">
          <head-info title="Results" :content="topCount.resultCount + ''" :center="false" />
        </a-col>
      </a-row> -->
    </div>
    <!-- 主视图 -->
    <div>
      <div>Welcome</div>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from '@/components/page/PageLayout'

export default {
  name: 'Workplace',
  components: {
    PageLayout
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>
